import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import ListSubheader from "@mui/material/ListSubheader";
import TabletAndroidIcon from "@mui/icons-material/TabletAndroid";
import ComputerIcon from "@mui/icons-material/Computer";
import PeopleIcon from "@mui/icons-material/People";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ReorderIcon from "@mui/icons-material/Reorder";
import HomeIcon from "@mui/icons-material/Home";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import RouterIcon from "@mui/icons-material/Router";
import BuildIcon from "@mui/icons-material/Build";
import EmailIcon from "@mui/icons-material/Email";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ApiIcon from "@mui/icons-material/Api";
import HandshakeIcon from "@mui/icons-material/Handshake";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import ModalEmail from "./ModalEmail";
import AxiosEnviar from "./AxiosEnviar";
import { snackbar } from "./snackbarService";

const formulariosIngemotions = [
  { titulo: "Formulario Alta Trabajador", path: "/ZonaPublica/formularios/57c74cab-e604-42fa-aca5-ea5e5405539e" },
  { titulo: "Formulario Baja Trabajador", path: "/ZonaPublica/formularios/afb8853c-6a83-425a-b4e9-b1e2bb87bdce" },
  { titulo: "Formulario Incidencias", path: "/ZonaPublica/formularios/a2a74802-6102-42a4-87a7-a594ccffd593" },
];

const formulariosErzia = [
  { titulo: "Formulario Alta Trabajador", path: "/ZonaPublica/formularios/7002351e-143a-4fbe-8cf0-ea08ea191063" },
  { titulo: "Formulario Baja Trabajador", path: "/ZonaPublica/formularios/2d8732bd-defa-4475-86c3-8e892675f2a6" },
];

const BarraNavegacion = ({ titulo, onLogout }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [, setAnchorMonitor] = useState(null);
  const [anchorUtilidades, setAnchorUtilidades] = useState(null);
  const [anchorTelco, setAnchorTelco] = useState(null);
  const [anchorApi, setAnchorApi] = useState(null);
  // Colaboración: accesos de clientes, agrupados por cliente (submenú)
  const [anchorColaboracion, setAnchorColaboracion] = useState(null);
  const [anchorColabSamsic, setAnchorColabSamsic] = useState(null);
  const [anchorColabIngemotions, setAnchorColabIngemotions] = useState(null);
  const [anchorColabAtlantis, setAnchorColabAtlantis] = useState(null);
  const [anchorColabErzia, setAnchorColabErzia] = useState(null);
  const [anchorComunicaciones, setAnchorComunicaciones] = useState(null);
  const [modalFichajeOpen, setModalFichajeOpen] = useState(false);
  const [modalFichajePasswordOpen, setModalFichajePasswordOpen] = useState(false);
  const [modalFichajePrimerosPasosOpen, setModalFichajePrimerosPasosOpen] = useState(false);
  const [modalDocumentacionB2Open, setModalDocumentacionB2Open] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMonitorClose = () => {
    setAnchorMonitor(null);
  };

  const handleUtilidadesOpen = (event) => {
    setAnchorUtilidades(event.currentTarget);
  };

  const handleUtilidadesClose = () => {
    setAnchorUtilidades(null);
  };

  const handleNavigateUtilidades = (path) => {
    navigate(path);
    handleUtilidadesClose();
  };

  // Formularios del menú móvil (en escritorio están en el menú Colaboración)
  const abrirNuevaPestanaMovil = (path) => {
    window.open(path, "_blank", "noopener,noreferrer");
    handleMenuClose();
  };

  const handleTelcoOpen = (event) => {
    setAnchorTelco(event.currentTarget);
  };

  const handleTelcoClose = () => {
    setAnchorTelco(null);
  };

  const handleNavigateTelco = (path) => {
    navigate(path);
    handleTelcoClose();
  };

  const handleApiOpen = (event) => {
    setAnchorApi(event.currentTarget);
  };

  const handleApiClose = () => {
    setAnchorApi(null);
  };

  const handleNavigateApi = (path) => {
    navigate(path);
    handleApiClose();
  };

  const cerrarColaboracion = () => {
    setAnchorColabSamsic(null);
    setAnchorColabIngemotions(null);
    setAnchorColabAtlantis(null);
    setAnchorColabErzia(null);
    setAnchorColaboracion(null);
  };

  const navegarColaboracion = (path) => {
    navigate(path);
    cerrarColaboracion();
  };

  const abrirPestanaColaboracion = (path) => {
    window.open(path, "_blank", "noopener,noreferrer");
    cerrarColaboracion();
  };

  const handleComunicacionesOpen = (event) => {
    setAnchorComunicaciones(event.currentTarget);
  };

  const handleComunicacionesClose = () => {
    setAnchorComunicaciones(null);
  };

  const enviarFichajeDigitalPresentacion = async (email, nombre) => {
    const result = await AxiosEnviar(
      '/clientes/enviarFichajeDigitalPresentacion',
      { nombre, correo: email },
      'POST',
      false
    );
    if (result) {
      snackbar.success('Presentación enviada correctamente.');
      setModalFichajeOpen(false);
    }
  };

  const enviarFichajeDigitalRegenerarPassword = async (email, nombre) => {
    const result = await AxiosEnviar(
      '/clientes/enviarFichajeDigitalRegenerarPassword',
      { nombre, correo: email },
      'POST',
      false
    );
    if (result) {
      snackbar.success('Instrucciones de contraseña enviadas correctamente.');
      setModalFichajePasswordOpen(false);
    }
  };

  const enviarFichajeDigitalPrimerosPasos = async (email, nombre) => {
    const result = await AxiosEnviar(
      '/clientes/enviarFichajeDigitalPrimerosPasos',
      { nombre, correo: email },
      'POST',
      false
    );
    if (result) {
      snackbar.success('Primeros pasos enviados correctamente.');
      setModalFichajePrimerosPasosOpen(false);
    }
  };

  const enviarDocumentacionB2 = async (email, nombre) => {
    const result = await AxiosEnviar(
      '/clientes/enviarDocumentacionB2',
      { nombre, correo: email },
      'POST',
      false
    );
    if (result) {
      snackbar.success('Documentación B2 enviada correctamente.');
      setModalDocumentacionB2Open(false);
    }
  };

  const handleNavigate = (path) => {
    navigate(path);
    handleMenuClose();
  };

  const abrirNuevaPestana = (path) => {
    window.open(path, "_blank");
    handleMonitorClose();
  };

  const renderMenuItems = () => (
    <>
      <MenuItem onClick={() => handleNavigate("/IA")}>IA</MenuItem>
      <MenuItem onClick={() => handleNavigate("/")}>Página Principal</MenuItem>
      <MenuItem onClick={() => handleNavigate("/Partes")}>Partes</MenuItem>
      <MenuItem onClick={() => handleNavigate("/Partes/Ordenables")}>Ord.</MenuItem>

      <MenuItem onClick={() => handleNavigate("/PartesAutomaticos")}>
        Partes Automáticos
      </MenuItem>
      <MenuItem onClick={() => handleNavigate("/Clientes")}>Clientes</MenuItem>
      <MenuItem onClick={() => handleNavigate("/Tablets")}>Tablets</MenuItem>
      {/* <MenuItem onClick={() => handleNavigate("/Revisiones")}>Revisiones</MenuItem> */}
      <MenuItem onClick={() => handleNavigate("/Dispositivos")}>
        Dispositivos
      </MenuItem>
      <MenuItem onClick={() => handleNavigate("/GLPI")}>
        GLPI
      </MenuItem>
      {/* <MenuItem onClick={() => handleNavigate("/PlantillasDispositivo")}>
        Plantillas
      </MenuItem> */}
      <MenuItem onClick={() => handleNavigate("/Telco/Endpoint")}>Endpoint</MenuItem>
      <MenuItem onClick={() => handleNavigate("/Telco/Fortinet")}>Fortinet</MenuItem>
      <MenuItem onClick={() => handleNavigate("/Telco/FTTH")}>FTTH</MenuItem>
      <MenuItem onClick={() => handleNavigate("/Telco/Servidores")}>Servidores</MenuItem>
      <MenuItem onClick={() => handleNavigate("/Telco/SIP")}>SIP</MenuItem>
      <Divider />
      <MenuItem onClick={() => handleNavigate("/Integracion/ActiveBackup")}>Integración: Active Backup</MenuItem>
      <MenuItem onClick={() => handleNavigate("/Integracion/DMI")}>Integración: DMI</MenuItem>
      <MenuItem onClick={() => handleNavigate("/Integracion/Fortinet")}>Integración: Fortinet</MenuItem>
      <MenuItem onClick={() => handleNavigate("/Integracion/Mikrotik")}>Integración: Mikrotik</MenuItem>
      <MenuItem onClick={() => handleNavigate("/Integracion/OVH")}>Integración: OVH</MenuItem>
      <MenuItem onClick={() => handleNavigate("/Integracion/Plesk")}>Integración: Plesk</MenuItem>
      <Divider />
      <MenuItem onClick={() => handleNavigate("/Utilidades/mac")}>
        Averiguar MAC
      </MenuItem>
      <MenuItem onClick={() => handleNavigate("/Utilidades/IpLocate")}>
        IP Locate
      </MenuItem>

      <Divider />
      <MenuItem onClick={() => handleNavigate("/PS")}>PS</MenuItem>
      <Divider />
      <MenuItem onClick={() => handleNavigate("/Utilidades/EtiquetaPostal")}>
        Etiqueta Postal
      </MenuItem>
      <MenuItem onClick={() => handleNavigate("/Utilidades/Tarjetas")}>
        Solicitudes de Tarjetas
      </MenuItem>
      <MenuItem onClick={() => handleNavigate("/Samsic/CreacionTarjeta")}>
        Creación tarjeta
      </MenuItem>
      <MenuItem
        onClick={() =>
          abrirNuevaPestanaMovil(
            "/ZonaPublica/solicitudTarjetas/e677f1a8-9683-4ca1-9c14-e889feb66682"
          )
        }
      >
        Formulario Tarjetas
      </MenuItem>
      <MenuItem
        onClick={() =>
          abrirNuevaPestanaMovil("/ZonaPublica/samsic/9f3a1b7c-4d28-4e6a-b1f0-7c5e2a9d84b6")
        }
      >
        Formulario Firma
      </MenuItem>
      <Divider />
      {formulariosIngemotions.map(({ titulo, path }) => (
        <MenuItem key={path} onClick={() => abrirNuevaPestanaMovil(path)}>
          Ingemotions - {titulo.replace("Formulario ", "")}
        </MenuItem>
      ))}
      <Divider />
      {formulariosErzia.map(({ titulo, path }) => (
        <MenuItem key={path} onClick={() => abrirNuevaPestanaMovil(path)}>
          Erzia - {titulo.replace("Formulario ", "")}
        </MenuItem>
      ))}

      {/* Nuevo submenú Monitor en móvil */}
      {/* <MenuItem onClick={handleMonitorOpen}>Monitor ▸</MenuItem>
      <Menu
        anchorEl={anchorMonitor}
        open={Boolean(anchorMonitor)}
        onClose={handleMonitorClose}
      >
        <MenuItem onClick={() => abrirNuevaPestana("/n8nAbb")}>
          Active Backup
        </MenuItem>
        <MenuItem onClick={() => abrirNuevaPestana("/n8nssl")}>SSL</MenuItem>
        <MenuItem onClick={() => abrirNuevaPestana("/n8nVeeam")}>
          Veeam Backup
        </MenuItem>
      </Menu> */}
    </>
  );

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          {isMobile ? (
            <>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={handleMenuOpen}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                {renderMenuItems()}
              </Menu>
            </>
          ) : (
            <Box sx={{ display: "flex", gap: 2 }}>
              <Tooltip title="Página Principal">
                <IconButton color="inherit" onClick={() => handleNavigate("/")}>
                  <HomeIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Dashboard">
                <IconButton color="inherit" onClick={() => handleNavigate("/dashBoard")}>
                  <HomeIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Clientes">
                <IconButton color="inherit" onClick={() => handleNavigate("/Clientes")}>
                  <PeopleIcon />
                </IconButton>
              </Tooltip>
              {/* <Button color="inherit" onClick={() => handleNavigate("/Revisiones")}>
              Revisiones
            </Button> */}
              <Tooltip title="Partes">
                <IconButton color="inherit" onClick={() => handleNavigate("/Partes")}>
                  <AssignmentIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Partes Ordenables">
                <IconButton color="inherit" onClick={() => handleNavigate("/Partes/Ordenables")}>
                  <ReorderIcon />
                </IconButton>
              </Tooltip>
              {/* <Button
              color="inherit"
              onClick={() => handleNavigate("/PartesAutomaticos")}
            >
              Automáticos
            </Button> */}
              <Tooltip title="Tablets">
                <IconButton color="inherit" onClick={() => handleNavigate("/Tablets")}>
                  <TabletAndroidIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Dispositivos">
                <IconButton color="inherit" onClick={() => handleNavigate("/Dispositivos")}>
                  <ComputerIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="GLPI">
                <IconButton color="inherit" onClick={() => handleNavigate("/GLPI")}>
                  <Inventory2Icon />
                </IconButton>
              </Tooltip>
              {/* <Button
              color="inherit"
              onClick={() => handleNavigate("/PlantillasDispositivo")}
            >
              Plantillas
            </Button> */}

              <Tooltip title="Telco">
                <IconButton color="inherit" onClick={handleTelcoOpen}>
                  <RouterIcon />
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={anchorTelco}
                open={Boolean(anchorTelco)}
                onClose={handleTelcoClose}
              >
                <MenuItem onClick={() => handleNavigateTelco("/Telco/Endpoint")}>Endpoint</MenuItem>
                <MenuItem onClick={() => handleNavigateTelco("/Telco/Fortinet")}>Fortinet</MenuItem>
                <MenuItem onClick={() => handleNavigateTelco("/Telco/FTTH")}>FTTH</MenuItem>
                <MenuItem onClick={() => handleNavigateTelco("/Utilidades/EstadoFortinet")}>Página de Estado Fortinet</MenuItem>
                <MenuItem onClick={() => handleNavigateTelco("/Telco/Servidores")}>Servidores</MenuItem>
                <MenuItem onClick={() => handleNavigateTelco("/Telco/SIP")}>SIP</MenuItem>
              </Menu>

              <Tooltip title="Utilidades">
                <IconButton color="inherit" onClick={handleUtilidadesOpen}>
                  <BuildIcon />
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={anchorUtilidades}
                open={Boolean(anchorUtilidades)}
                onClose={handleUtilidadesClose}
              >
                <MenuItem onClick={() => handleNavigateUtilidades("/Utilidades/mac")}>
                  Averiguar MAC
                </MenuItem>
                <MenuItem onClick={() => handleNavigateUtilidades("/Utilidades/Backups")}>
                  Backups
                </MenuItem>
                <MenuItem onClick={() => handleNavigateUtilidades("/Utilidades/Bitacora")}>
                  Bitacora
                </MenuItem>
                <MenuItem onClick={() => handleNavigateUtilidades("/Utilidades/ClaveSegura")}>
                  Clave Segura
                </MenuItem>
                <MenuItem onClick={() => handleNavigateUtilidades("/Utilidades/EnviarSMS")}>
                  Enviar SMS
                </MenuItem>
                <MenuItem onClick={() => handleNavigateUtilidades("/Utilidades/EstadisticaTaller")}>
                  Estadística Taller
                </MenuItem>
                <MenuItem onClick={() => handleNavigateUtilidades("/Utilidades/Facturacion")}>
                  Facturacion
                </MenuItem>
                <MenuItem onClick={() => handleNavigateUtilidades("/Utilidades/IpLocate")}>
                  IP Locate
                </MenuItem>
                <MenuItem onClick={() => handleNavigateUtilidades("/Utilidades/ClaveSeguridad")}>
                  Mi clave de seguridad
                </MenuItem>
                <MenuItem onClick={() => handleNavigateUtilidades("/Utilidades/Nomenclaturas")}>
                  Nomenclaturas
                </MenuItem>
                <MenuItem onClick={() => handleNavigateUtilidades("/Utilidades/ProgramadorPartes")}>
                  Programador de partes
                </MenuItem>
                <MenuItem onClick={() => handleNavigateUtilidades("/Utilidades/Protocolos")}>
                  Protocolos
                </MenuItem>
                <MenuItem onClick={() => handleNavigateUtilidades("/Utilidades/ServiciosExternos")}>
                  Servicios Externos
                </MenuItem>
                <MenuItem onClick={() => handleNavigateUtilidades("/Utilidades/Software")}>
                  Software
                </MenuItem>
                <MenuItem onClick={() => handleNavigateUtilidades("/Utilidades/Tareas")}>
                  Tareas
                </MenuItem>
                <MenuItem onClick={() => handleNavigateUtilidades("/Utilidades/TopTen")}>
                  TopTen
                </MenuItem>
              </Menu>

              <Tooltip title="Comunicaciones">
                <IconButton color="inherit" onClick={handleComunicacionesOpen}>
                  <EmailIcon />
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={anchorComunicaciones}
                open={Boolean(anchorComunicaciones)}
                onClose={handleComunicacionesClose}
              >
                <ListSubheader>FichajeDigital</ListSubheader>
                <MenuItem onClick={() => { setModalFichajeOpen(true); handleComunicacionesClose(); }}>
                  Envío Presentación
                </MenuItem>
                <MenuItem onClick={() => { setModalFichajePasswordOpen(true); handleComunicacionesClose(); }}>
                  Regenerar Password
                </MenuItem>
                <MenuItem onClick={() => { setModalFichajePrimerosPasosOpen(true); handleComunicacionesClose(); }}>
                  Primeros Pasos
                </MenuItem>
                <ListSubheader>Documentación</ListSubheader>
                <MenuItem onClick={() => { setModalDocumentacionB2Open(true); handleComunicacionesClose(); }}>
                  B2
                </MenuItem>
              </Menu>
              <Tooltip title="IA">
                <IconButton color="inherit" onClick={() => handleNavigate("/IA")}>
                  <AutoAwesomeIcon />
                </IconButton>
              </Tooltip>
              <Button color="inherit" onClick={() => handleNavigate("/PS")} sx={{ minWidth: 0, fontWeight: "bold" }}>
                PS
              </Button>
              <Tooltip title="Integración">
                <IconButton color="inherit" onClick={handleApiOpen}>
                  <ApiIcon />
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={anchorApi}
                open={Boolean(anchorApi)}
                onClose={handleApiClose}
              >
                <MenuItem onClick={() => handleNavigateApi("/Integracion/ActiveBackup")}>Active Backup</MenuItem>
                <MenuItem onClick={() => handleNavigateApi("/Integracion/DMI")}>DMI</MenuItem>
                <MenuItem onClick={() => handleNavigateApi("/Integracion/Fortinet")}>Fortinet</MenuItem>
                <MenuItem onClick={() => handleNavigateApi("/Integracion/Mikrotik")}>Mikrotik</MenuItem>
                <MenuItem onClick={() => handleNavigateApi("/Integracion/OVH")}>OVH</MenuItem>
                <MenuItem onClick={() => handleNavigateApi("/Integracion/Plesk")}>Plesk</MenuItem>
              </Menu>
              <Tooltip title="Colaboración">
                <IconButton color="inherit" onClick={(e) => setAnchorColaboracion(e.currentTarget)}>
                  <HandshakeIcon />
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={anchorColaboracion}
                open={Boolean(anchorColaboracion)}
                onClose={cerrarColaboracion}
              >
                <MenuItem
                  onClick={(e) => setAnchorColabAtlantis(e.currentTarget)}
                  selected={Boolean(anchorColabAtlantis)}
                  sx={{ gap: 1 }}
                >
                  Atlantis PC
                  <ChevronRightIcon fontSize="small" sx={{ ml: "auto" }} />
                </MenuItem>
                <MenuItem
                  onClick={(e) => setAnchorColabErzia(e.currentTarget)}
                  selected={Boolean(anchorColabErzia)}
                  sx={{ gap: 1 }}
                >
                  Erzia
                  <img
                    src="/logoErzia.png"
                    alt=""
                    style={{ height: 20, width: "auto", borderRadius: 3 }}
                  />
                  <ChevronRightIcon fontSize="small" sx={{ ml: "auto" }} />
                </MenuItem>
                <MenuItem
                  onClick={(e) => setAnchorColabIngemotions(e.currentTarget)}
                  selected={Boolean(anchorColabIngemotions)}
                  sx={{ gap: 1 }}
                >
                  Ingemotions
                  {/* El jpg tiene mucho margen blanco: se recorta al logo con overflow */}
                  <Box sx={{ width: 67, height: 20, overflow: "hidden", borderRadius: "3px", backgroundColor: "#fff" }}>
                    <img
                      src="/logoIngemotions.jpg"
                      alt=""
                      style={{ width: 83, height: "auto", margin: "-15px 0 0 -8px", display: "block" }}
                    />
                  </Box>
                  <ChevronRightIcon fontSize="small" sx={{ ml: "auto" }} />
                </MenuItem>
                <MenuItem
                  onClick={(e) => setAnchorColabSamsic(e.currentTarget)}
                  selected={Boolean(anchorColabSamsic)}
                  sx={{ gap: 1 }}
                >
                  Samsic
                  <img
                    src="https://sat.cloudlsf.es/logoSamsic.jpg"
                    alt=""
                    style={{ height: 20, width: "auto", borderRadius: 3 }}
                  />
                  <ChevronRightIcon fontSize="small" sx={{ ml: "auto" }} />
                </MenuItem>
              </Menu>
              <Menu
                anchorEl={anchorColabErzia}
                open={Boolean(anchorColabErzia)}
                onClose={() => setAnchorColabErzia(null)}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
              >
                {formulariosErzia.map(({ titulo, path }) => (
                  <MenuItem key={path} onClick={() => abrirPestanaColaboracion(path)}>
                    {titulo}
                  </MenuItem>
                ))}
              </Menu>
              <Menu
                anchorEl={anchorColabAtlantis}
                open={Boolean(anchorColabAtlantis)}
                onClose={() => setAnchorColabAtlantis(null)}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
              >
                {/* Historial de navegación público del Fortinet 25 (ver FortinetController::ESTADISTICAS_PUBLICAS) */}
                <MenuItem
                  onClick={() =>
                    abrirPestanaColaboracion("/ZonaPublica/Estadisticas/Fortinet/b454bb5b-5de4-4d0e-9595-f0995be69de7")
                  }
                >
                  Forti Vidroplast
                </MenuItem>
              </Menu>
              <Menu
                anchorEl={anchorColabIngemotions}
                open={Boolean(anchorColabIngemotions)}
                onClose={() => setAnchorColabIngemotions(null)}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
              >
                {formulariosIngemotions.map(({ titulo, path }) => (
                  <MenuItem key={path} onClick={() => abrirPestanaColaboracion(path)}>
                    {titulo}
                  </MenuItem>
                ))}
              </Menu>
              <Menu
                anchorEl={anchorColabSamsic}
                open={Boolean(anchorColabSamsic)}
                onClose={() => setAnchorColabSamsic(null)}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
              >
                <MenuItem onClick={() => navegarColaboracion("/Utilidades/EtiquetaPostal")}>
                  Etiqueta Postal
                </MenuItem>
                <MenuItem onClick={() => navegarColaboracion("/Utilidades/Tarjetas")}>
                  Solicitudes de Tarjetas
                </MenuItem>
                <MenuItem onClick={() => navegarColaboracion("/Samsic/CreacionTarjeta")}>
                  Creación tarjeta
                </MenuItem>
                <Divider />
                <MenuItem
                  onClick={() =>
                    abrirPestanaColaboracion("/ZonaPublica/solicitudTarjetas/e677f1a8-9683-4ca1-9c14-e889feb66682")
                  }
                >
                  Formulario Tarjetas
                </MenuItem>
                <MenuItem
                  onClick={() =>
                    abrirPestanaColaboracion("/ZonaPublica/samsic/9f3a1b7c-4d28-4e6a-b1f0-7c5e2a9d84b6")
                  }
                >
                  Formulario Firma
                </MenuItem>
              </Menu>
            </Box>
          )}
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, textAlign: "center" }}
          >
            {isMobile ? "SAT LSF" : titulo || "Servicio Asistencia Técnica LSF"}
          </Typography>
          <Button color="inherit" onClick={onLogout}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>
      <ModalEmail
        open={modalFichajeOpen}
        onClose={() => setModalFichajeOpen(false)}
        onEnviar={enviarFichajeDigitalPresentacion}
        titulo="Enviar presentación de FichajeDigital"
        descripcion="Se enviará la presentación de FichajeDigital al destinatario indicado."
        pedirNombre={true}
        textoBotonEnviar="Enviar"
      />
      <ModalEmail
        open={modalFichajePasswordOpen}
        onClose={() => setModalFichajePasswordOpen(false)}
        onEnviar={enviarFichajeDigitalRegenerarPassword}
        titulo="Enviar instrucciones para regenerar contraseña"
        descripcion="Se enviará al destinatario un correo con los pasos para recuperar su acceso a FichajeDigital."
        pedirNombre={true}
        textoBotonEnviar="Enviar"
      />
      <ModalEmail
        open={modalFichajePrimerosPasosOpen}
        onClose={() => setModalFichajePrimerosPasosOpen(false)}
        onEnviar={enviarFichajeDigitalPrimerosPasos}
        titulo="Enviar primeros pasos en FichajeDigital"
        descripcion="Se enviará al destinatario un correo con las guías de inicio para empezar a usar FichajeDigital."
        pedirNombre={true}
        textoBotonEnviar="Enviar"
      />
      <ModalEmail
        open={modalDocumentacionB2Open}
        onClose={() => setModalDocumentacionB2Open(false)}
        onEnviar={enviarDocumentacionB2}
        titulo="Enviar solicitud de documentación B2 Group"
        descripcion="Se enviará al destinatario un correo con la documentación necesaria para el alta en B2 Group."
        pedirNombre={true}
        textoBotonEnviar="Enviar"
      />
    </>
  );
};

export default BarraNavegacion;
